import React, {Component, ReactNode} from 'react'
import {MeetingCommentFile} from '../model/MeetingCommentFile'
import {DialogContent, DialogTitle} from '@mui/material'
import {UnstyledLinkStyledButton} from '../../../styledComponents/Button'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faTimes} from '@fortawesome/free-solid-svg-icons'
import MeetingCommentInputForm, {InputError} from './MeetingCommentInputForm'
import styled from 'styled-components'
import {Colors, FontFamily, FontWeights} from '../../../styledComponents/Constants'
import {RowFlexContainer} from '../../../styledComponents/FlexComponents'

interface Props {
    onClickSubmitButton: () => Promise<void>
    onClickCloseButton: () => void
    onChange: (
        content: string,
        commentFileList: MeetingCommentFile[],
        deleteFileNumberList: number[],
        inputError?: InputError,
    ) => void
    content: string
    commentFileList: MeetingCommentFile[]
    deleteFileNumberList: number[]
    commentInputError?: InputError
}

class MeetingCommentEditDialog extends Component<Props> {

    constructor(props: Readonly<Props>) {
        super(props)
    }

    render(): ReactNode {
        const {
            onClickSubmitButton,
            onClickCloseButton,
            onChange,
            content,
            commentFileList,
            deleteFileNumberList,
            commentInputError,
        } = this.props

        return (<>
            <StyledDialogTitle>
                <RowFlexContainer>
                    コメント編集
                    <UnstyledLinkStyledButton
                        id={'closeButton'}
                        onClick={onClickCloseButton}
                    >
                        <FontAwesomeIcon icon={faTimes} size={'lg'}/>
                    </UnstyledLinkStyledButton>
                </RowFlexContainer>
            </StyledDialogTitle>
            <StyledDialogContent>
                <MeetingCommentInputForm
                    inDialog
                    submitButtonLabel={'完了'}
                    onClickSubmitButton={onClickSubmitButton}
                    onClickCancelButton={onClickCloseButton}
                    onChange={onChange}
                    content={content}
                    commentFileList={commentFileList}
                    deleteFileNumberList={deleteFileNumberList}
                    inputError={commentInputError}
                />
            </StyledDialogContent>
        </>)
    }
}

export default MeetingCommentEditDialog

const StyledDialogTitle = styled(DialogTitle)`
  &.MuiDialogTitle-root {
    padding: 17px 15px 17px 15px;
    border-bottom: 1px solid ${Colors.Background};
  }

  &.MuiTypography-h6 {
    color: ${Colors.AccentDark};
    font-size: 20px;
    font-family: ${FontFamily.ResidentDefault};
    font-weight: ${FontWeights.Bold};
  }
`

const StyledDialogContent = styled(DialogContent)`
  &.MuiDialogContent-root {
    padding: 15px 15px 15px 15px;
    flex-grow: 2;
  }
`
